const body = document.body;

/**
 * Open search popup
 * @param e
 * @returns {boolean}
 */
let openPopupSearch = function (e) {
	e.preventDefault();
	e.stopPropagation();

	// open popup search
	body.classList.add('popup-search-open');
	body.classList.remove('menu-open');
	document.getElementById('menu-toggle').classList.remove('tcon-transform');

	let container = document.querySelector('.search-popup');

	// scroll to top
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'instant',
	});

	container.querySelector('.search-field').focus();

	// Close search popup when the user clicks outside the popup
	body.addEventListener('click', function (e) {
		// if the target of the click isn't the container nor a descendant of the container
		if (container !== e.target && !container.contains(e.target))
		{
			body.classList.remove('popup-search-open');
			body.removeEventListener('click', openPopupSearch);
		}
	});

	return false;
}

document.querySelector('.open-popup-search').addEventListener('click', openPopupSearch);


/**
 * Close search popup
 * @type {Element}
 */
let closePopupSearch = document.querySelector('.close-popup-search');

if (closePopupSearch)
{
	closePopupSearch.addEventListener('click', function (e) {
		e.preventDefault();

		// close popup search
		body.classList.remove('popup-search-open');

		return false;
	});
}

// Select ALL search forms on the page
document.querySelectorAll('.search-form').forEach(form => {

	// Get elements INSIDE the current form (scoped query like jQuery context)
	const searchField = form.querySelector('.search-field');
	const resetBtn    = form.querySelector('.search-reset');
	const submitBtn   = form.querySelector('.search-submit');

	// If any required element is missing → skip this form safely
	if (!searchField || !resetBtn || !submitBtn)
	{
		return;
	}

	// -----------------------------
	// RESET BUTTON CLICK HANDLER
	// -----------------------------
	resetBtn.addEventListener('click', e => {
		e.preventDefault(); // prevent form submit / link navigation

		// Clear search input value
		searchField.value = '';

		// Put cursor back in the searchField
		searchField.focus();

		// Hide reset button
		resetBtn.style.display = 'none';

		// Show submit button
		submitBtn.style.display = 'block';
	});

	// -----------------------------
	// USER TYPING IN SEARCH searchField
	// -----------------------------
	searchField.addEventListener('keyup', () => {

		// Hide reset button while typing
		resetBtn.style.display = 'none';

		// Ensure submit button is visible
		submitBtn.style.display = 'block';
	});

});